import axios from 'axios';
import { WalkthroughFlow } from 'models/chatbot';
interface ChatRequest {
  query: string;
  // eslint-disable-next-line camelcase
  session_id: string;
  // eslint-disable-next-line camelcase
  id_user: number;
  // eslint-disable-next-line camelcase
  id_program: number;
  // eslint-disable-next-line camelcase
  id_company: number;
  // eslint-disable-next-line camelcase
  model_name: string;
  // eslint-disable-next-line camelcase
  use_neighbors: boolean;
  // eslint-disable-next-line camelcase
  client_ctx: string;
  temperature: number;
  // eslint-disable-next-line camelcase
  suppress_history: boolean;
  // eslint-disable-next-line camelcase
  tools_enabled: boolean;
  // eslint-disable-next-line camelcase
  suppress_context: boolean;
  // eslint-disable-next-line camelcase
  only_validated: boolean;
}

interface ChatResponse {
  answer: string;
  responseTime?: number;
  links?: Array<{
    document: string;
    page: number;
    url: string;
  }>;
  previews: any[];
  attachments: any[];
  // eslint-disable-next-line camelcase
  chat_history_id: string;
  // eslint-disable-next-line camelcase
  walkthrough_flows: WalkthroughFlow[];
  images?: Array<{
    // eslint-disable-next-line camelcase
    mime_type: string;
    url: string;
  }>;
  audios?: Array<{
    // eslint-disable-next-line camelcase
    mime_type: string;
    url?: string;
    // eslint-disable-next-line camelcase
    audio_base64?: string;
  }>;
}

interface Tool {
  id: string;
  name: string;
  description: string;
  enabled: boolean;
}

interface ChatFeedback {
  // eslint-disable-next-line camelcase
  session_id: string;
  // eslint-disable-next-line camelcase
  id_user: number;
  // eslint-disable-next-line camelcase
  id_program: number;
  rating?: number;
  // eslint-disable-next-line camelcase
  chat_history_id: string;
  // eslint-disable-next-line camelcase
  problem_type?: string;
  comment?: string;
  metadata?: {
    browser?: string;
    os?: string;
    model?: string;
  };
}

export const chatbotService = {
  fetchModels: async (): Promise<string[]> => {
    try {
      // Remove trackPromise to prevent global loader from showing for model fetching
      const response = await axios.post<string[]>('/chatbot/api/info/models/available');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch chatbot models:', error);
      throw error;
    }
  },

  fetchTools: async (): Promise<Tool[]> => {
    try {
      const response = await axios.post<Tool[]>('/chatbot/api/info/tools/available');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch chatbot tools:', error);
      throw error;
    }
  },

  sendChatMessage: async (request: ChatRequest, signal?: AbortSignal): Promise<ChatResponse> => {
    return chatbotService.sendChatRequest('/chatbot/api/chat/text', request, signal);
  },

  sendChatMessageMultimodal: async (request: ChatRequest, signal?: AbortSignal): Promise<ChatResponse> => {
    return chatbotService.sendChatRequest('/chatbot/api/chat/multimodal', request, signal);
  },

  sendChatRequest: async (endpoint: string, request: ChatRequest, signal?: AbortSignal): Promise<ChatResponse> => {
    try {
      const startTime = Date.now();
      const response = await axios.post<ChatResponse>(endpoint, request, {
        headers: { 'Content-Type': 'application/json' },
        signal,
      });
      const endTime = Date.now();

      return {
        ...response.data,
        responseTime: endTime - startTime,
      };
    } catch (error) {
      console.error('Failed to send chat message:', error);
      throw error;
    }
  },

  sendFeedback: async (feedback: ChatFeedback): Promise<void> => {
    try {
      await axios.post<ChatFeedback>('/chatbot/api/feedback/save', feedback, {
        headers: { 'Content-Type': 'application/json' },
      });
    } catch (error) {
      console.error('Failed to send chat feedback:', error);
      throw error;
    }
  },
};

export default chatbotService;
